


















import Vue, { PropOptions } from 'vue'

export default Vue.extend({
  name: 'ArticleReferences',
  functional: true,
  props: {
    references: {
      type: Array,
      required: true
    } as PropOptions<
      {
        text: string
        url: string
      }[]
    >
  }
})
